import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import { Field, reduxForm } from 'redux-form';

import {
  Button,
  FormControl,
  Panel,
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from '../ViewReviewAdminMessage.css';
import bt from '../../../components/commonStyle.css';

// Helpers
import submit from './submit';
import validate from './validate';

// Component
import Avatar from '../../Avatar';

//Locale
import messages from '../../../locale/messages';

// Images
import sendIcon from '/public/viewMessage/sendIcon.svg';
import { withChatValidation } from '../../../helpers/chat/withChatValidation';

class SendMessage extends Component {
  static propTypes = {
    threadId: PropTypes.number.isRequired,
    profileId: PropTypes.number.isRequired,
    picture: PropTypes.string,
    displayName: PropTypes.string.isRequired,
    formatMessage: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.state = { message: '' };
    this.formRef = React.createRef(); // Crea una referencia al formulario
  }

  componentDidMount() {
    if (this.formRef.current) {
      this.formRef.current.addEventListener('submit', this.handleFormSubmit);
    }
  }

  componentWillUnmount() {
    if (this.formRef.current) {
      this.formRef.current.removeEventListener('submit', this.handleFormSubmit);
    }
  }

  handleFormSubmit = (event) => {
    const { validation } = this.props;
    if (validation.isBlocked) {
      event.preventDefault();
      return;
    }

    this.setState({ message: '' });
  };

  handleChange = (e) => {
    const { validateMessage } = this.props;
    const message = e.target.value;
    this.setState({ message });
    validateMessage(message);
  };

  renderFormControlTextArea = ({ input, label, meta: { touched, error }, children, className, placeholder }) => {
    const { formatMessage } = this.props.intl;
    const { message } = this.state;
    const { validation } = this.props;
    return (
      <div>
        <FormControl
          {...input}
          onInput={this.handleChange}
          value={message}
          className={className}
          componentClass="textarea"
          placeholder={placeholder}
        >
          {children}
        </FormControl>
        {touched && error && <span className={cx(s.errorMessage, 'errorMessageFieldRTL')}>{formatMessage(error)}</span>}
        {validation.errorMessage && (
          <span className={cx(s.validationMessage, 'validationMessageRTL')}>
            {validation.errorMessage}
          </span>
        )}
      </div>
    );
  }

  validateSubmit(e) {
    const { handleSubmit, validation } = this.props;

    if (validation.isBlocked) {
      e.preventDefault();
      return;
    }

    handleSubmit((formValues) => {
      submit(formValues);
      this.setState({ message: '' });
    })(e);
  }

  render() {
    const { profileId, picture, displayName } = this.props;
    const { error, handleSubmit, submitting, validation } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div className={cx(s.messageBoxSection, 'bgBlackTwo')}>
        <div className={cx(s.radiusColor, 'sendMessageRadius', s.topRadiusColor, 'topRadiusColorRTL', 'darkModeRadiusColor', 'sendMessageRadiusRTL')}>
          <form
            ref={this.formRef}
            onSubmit={handleSubmit(submit)}
            className={cx(s.messageForm, 'messageFormRTL')}
          >
            <div className={s.displayFlex}>
              <div className={cx(s.messageBoxStyle, s.topMessageBar, 'topMessageBarRTL', s.panelBubble, s.panelBubbleRight, "messageTextArea", 'ViewBubbleRight')}>
                <Field
                  name="content"
                  className={cx(s.textAreaBox, 'textAreaBoxRTL')}
                  component={this.renderFormControlTextArea}
                  placeholder={formatMessage(messages.writeMessage)}
                />
              </div>
              <div className={cx('textAlignLeftRtl', s.messageSendBtnSec, 'messageSendBtnSecRTL')}>
                <Button className={cx(s.messageSendIcon, 'messageSendIconRTL')} type={validation.isBlocked ? "button" : "submit"} disabled={submitting || error || validation.isBlocked}>
                  <img src={sendIcon} alt='' className={s.msgSendIcon} />
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

SendMessage = reduxForm({
  form: 'SendMessage', // a unique name for this form
  validate
})(SendMessage);

export default injectIntl(withStyles(s, bt)(withChatValidation(SendMessage)));